import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { money, fmtDate, titleCase } from "@/lib/format";
import { ShoppingBag } from "lucide-react";

export default function AdminOrders() {
  const [items, setItems] = useState([]);
  const [forbidden, setForbidden] = useState(false);
  useEffect(() => {
    api.get("/admin/orders").then((r) => setItems(r.data)).catch((e) => { if (e.response?.status === 403) setForbidden(true); });
  }, []);
  return (
    <div data-testid="admin-orders">
      <div className="flex items-center gap-2 mb-1"><ShoppingBag className="text-[#c9a86a]" size={22} /><h1 className="text-2xl font-semibold">Orders</h1></div>
      <p className="text-sm text-[var(--text-2)] mb-4">Merch &amp; deposit orders. Stripe checkout is live — paid orders update automatically.</p>
      {forbidden ? (
        <Card className="p-8 text-center text-[var(--text-2)] border-[var(--border-lch)]">You do not have access to orders.</Card>
      ) : (
        <Card className="border-[var(--border-lch)] overflow-hidden"><div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-[var(--panel-2)] text-[var(--text-2)] text-xs uppercase"><tr>
            <th className="text-left p-3">Order</th><th className="text-left p-3">Type</th><th className="text-left p-3">Customer</th>
            <th className="text-left p-3">Amount</th><th className="text-left p-3">Status</th><th className="text-left p-3">Date</th></tr></thead>
          <tbody>
            {items.map((o) => (
              <tr key={o.id} className="border-t border-[var(--border-lch)]">
                <td className="p-3 font-mono text-xs">{o.id?.slice(0, 8)}</td><td className="p-3">{titleCase(o.order_type)}</td>
                <td className="p-3">{o.customer_email || "—"}</td><td className="p-3">{money(o.amount)}</td>
                <td className="p-3"><Badge variant="outline">{titleCase(o.status)}</Badge></td><td className="p-3 text-[var(--text-2)]">{fmtDate(o.created_at)}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={6} className="p-8 text-center text-[var(--muted)]">No orders yet.</td></tr>}
          </tbody></table></div></Card>
      )}
    </div>
  );
}
